import { BaseApiClient } from '../client'
import type { WebhookEndpoint, WebhookDelivery } from '@/lib/types'

type DeliveryPlatformFilter = 'webhook' | 'klaviyo' | undefined

export class WebhooksApi extends BaseApiClient {
  async getEndpoints() {
    return this.request<WebhookEndpoint[]>('/api/admin/outbound-webhooks/endpoints')
  }

  async createEndpoint(data: Partial<WebhookEndpoint>) {
    return this.request<WebhookEndpoint>('/api/admin/outbound-webhooks/endpoints', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  async deleteEndpoint(id: string) {
    return this.request<void>(`/api/admin/outbound-webhooks/endpoints/${id}`, {
      method: 'DELETE',
    })
  }

  async toggleEndpoint(id: string, active: boolean) {
    return this.request<WebhookEndpoint>(`/api/admin/outbound-webhooks/endpoints/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ active }),
    })
  }

  async pingEndpoint(id: string) {
    return this.request<{ success: boolean; deliveryId: string }>(
      `/api/admin/outbound-webhooks/endpoints/${id}/ping`,
      {
        method: 'POST',
      }
    )
  }

  async getDeliveries(limit = 20, offset = 0, platform?: DeliveryPlatformFilter) {
    const params = new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
    })
    if (platform) {
      params.set('platform', platform)
    }
    return this.request<WebhookDelivery[]>(
      `/api/admin/outbound-webhooks/deliveries?${params.toString()}`
    )
  }
}
